"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getSize(words, fontSize) {
    if (fontSize === void 0) { fontSize = 14; }
    return Math.max.apply(Math, words.map(function (word) {
        var span = document.createElement('span');
        span.innerText = word.toString();
        span.style.fontSize = fontSize + "px";
        document.body.appendChild(span);
        var offsetWidth = span.offsetWidth;
        document.body.removeChild(span);
        return offsetWidth || 0;
    }));
}
exports.getSize = getSize;
